import { render, staticRenderFns } from "./SetNicknameModal.vue?vue&type=template&id=38dd9c83"
import script from "./SetNicknameModal.vue?vue&type=script&lang=js"
export * from "./SetNicknameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports